import SignUpLogo from "./../../logo192.png";
import styles from "./forbidden_page.module.scss";

export default function ForbiddenPage() {
  return (
    <div className={styles.forbiddenPage}>
      <div className={styles.forbiddenContent}>
        <div className={styles.logoWrap}>
          <img src={SignUpLogo} alt="Logo" className={styles.logo} />
        </div>
        <h1 className={styles.errorCode}>403</h1>
        <h2 className={styles.errorTitle}>Access Forbidden</h2>
        <p className={styles.errorMessage}>
          Sorry, you don’t have permission to view this page.
        </p>
        <button
          className={styles.homeButton}
          onClick={() => window.location.replace("/")}
        >
          Go Back Home
        </button>
      </div>
    </div>
  );
}
